export const APP_VERSION = "V-25.10.1.0.1001";
